import { useState } from "react";

import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import FaqCollapse from "pages/LandingPages/Rental/components/FaqCollapse";

function FaqAccordionList({ items }) {
  const [openItem, setOpenItem] = useState(0);

  return (
    <MKBox>
      {items.map((item, index) => (
        <FaqCollapse
          key={item.question}
          title={item.question}
          open={openItem === index}
          onClick={() => setOpenItem(openItem === index ? -1 : index)}
        >
          {item.answer}
        </FaqCollapse>
      ))}
    </MKBox>
  );
}

FaqAccordionList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default FaqAccordionList;
